import React, { useEffect, useState } from "react";
import { Container } from "olive-react-myoneui";
import CourseListingTabs from "../../components/student-dashboard/course-listing";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import axios from "../../utils/axios";
import { API_URL } from "../../constants/config";
import { setUserItemApprovalData } from "../../reducers/userItemApprovalSlice";
import { useDispatch } from "react-redux";
// import OliveLogo from "../assets/images/olivegroup-logo.svg";

function CourseListing() {
  const dispatch = useDispatch();
  
  useEffect(()=>{
    fetchUserItemApprovals();
  },[]);

  const fetchUserItemApprovals = async () => {
    const response = await axios.post(`${API_URL}api/front_end/list_user_item_approvals`);
    const approvalItemIds = response.data.data.map((item) => item.uia_item_id);
    dispatch(setUserItemApprovalData({ existingApprovalIds : approvalItemIds}));
}

  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div className="w-100 py-4">
        <Container>
          <CourseListingTabs /> 
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default CourseListing;
